import React from 'react'

import { useAuth } from '@/auth/AuthContext'

import { UnauthorizedView } from './unauthorized'

export const StaffGuard: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { isStaff } = useAuth()
  return isStaff ? <>{children}</> : <UnauthorizedView />
}
